import { Button, ButtonProps, Col, Row } from 'antd';
import { CSSProperties, ReactNode } from 'react';
import LabelWithToolTip from './LabelWithToolTip';

interface LabelWrapperProps {
    label?: string;
    rightActionText?: string;
    onClickRightAction?: ButtonProps['onClick'];
    tooltip?: string;
    icon?: ReactNode;
    style?: CSSProperties;
}

export default function LabelWrapper({
    label,
    rightActionText,
    onClickRightAction,
    style,
    tooltip,
    icon
}: LabelWrapperProps) {
    return (
        <Row justify="space-between" align="middle" style={style}>
            <Col>{label && <LabelWithToolTip tooltip={tooltip}>{label}</LabelWithToolTip>}</Col>
            <Col>
                {(rightActionText || onClickRightAction) && (
                    <Button
                        type="link"
                        size="small"
                        style={{ fontSize: 11, paddingRight: 0 }}
                        onClick={onClickRightAction}
                        {...(icon && { icon })}
                    >
                        {rightActionText?.toLocaleLowerCase()}
                    </Button>
                )}
            </Col>
        </Row>
    );
}
